// Name of an AI Studio grid image in the company's "AI Studio" folder (POR-14659):
// type, version and the moment it finished. Every grid of a company shares that
// folder, so "Lifestyle v1" alone would pile up as "Lifestyle_v1 (347)" and make the
// server's name de-dup check S3 once per earlier copy.
//
// Pure (no imports) so it can be verified with `node --test`.
export function aiStudioFileName(label, versionNumber, date = new Date()) {
  const pad = (value) => String(value).padStart(2, '0');
  const stamp = `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`
    + `-${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;

  return `${label || 'AI Studio image'} v${versionNumber} ${stamp}`;
}
